import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IGallery } from "../galleryModal";

export const getAllGallerys = createAsyncThunk(
  "Gallery/FindAllGallery",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Gallery/FindAllGallery`,
        {}
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Gallery images:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createGallery = createAsyncThunk(
  "Gallery/InsertGallery",
  async (GalleryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Gallery/InsertGallery`,
        GalleryData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Gallery Image:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateGallery = createAsyncThunk(
  "Gallery/CreateOrUpdateGallery",
  async (GalleryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Gallery/CreateOrUpdateGallery`,
        GalleryData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Gallery Image:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteGallery = createAsyncThunk(
  "Gallery/DeleteGallery",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Gallery/DeleteGallery`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Gallery Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getGalleryByID = createAsyncThunk(
  "Gallery/FindByIDGallery",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Gallery/FindByIDGallery`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        ImgAlt: result?.ImgAlt ?? "",
        GalleryImage: result?.GalleryImage ?? "",
        IsActive: result.IsActive ? 1 : 2,
      } as IGallery;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Gallery Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveGallerys = createAsyncThunk(
  "Gallery/FindAllActiveGallery",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Gallery/FindAllActiveGallery`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Gallery images:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveGallery = createAsyncThunk(
  "Gallery/ActiveInActiveGallery",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Gallery/ActiveInActiveGallery`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Gallery Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

// export const GalleryImageUpload = createAsyncThunk(
//   "Gallery/UpdateGallery",
//   async (formData: any) => {
//     try {
//       const response = await axiosApiInstance.post(
//         `${API_URL}/Gallery/UpdateGallery`,
//         formData,
//         {
//           headers: { "content-type": "multipart/form-data" },
//         }
//       );
//       SuccessToast(response.data?.Details || "Success");
//       return response.data;
//     } catch (error: any) {
//       ErrorToast(error?.response?.data?.Details || "Something went wrong");
//       console.error("Error upload Gallery Image Image :", error);
//       return Promise.reject({
//         message: error?.response?.data?.Details || "Something went wrong",
//       });
//     }
//   }
// );
